module.exports = __webpack_public_path__ + "static/media/replyd.16a4c379.svg";